import { render, staticRenderFns } from "./HeaderAdmin.vue?vue&type=template&id=ef100096&scoped=true&"
import script from "./HeaderAdmin.vue?vue&type=script&lang=js&"
export * from "./HeaderAdmin.vue?vue&type=script&lang=js&"
import style0 from "./HeaderAdmin.vue?vue&type=style&index=0&id=ef100096&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef100096",
  null
  
)

export default component.exports